import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
export const AddAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "AttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};
export const AddSDocAttachment = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.AttachmentAPI}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "SDocAttchmentUploaded",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "SDocAttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};
export const DownloadAttachment = (attachmentDetail) => {
  let url = `${API.DownloadAttachmentAPI}?filename=${btoa(
    attachmentDetail.attachmentName
  )}&guidValue=${attachmentDetail.attachmentGuid}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, attachmentDetail.attachmentName);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const UpdatePoDetails = (postItem) => {
  //   const data = new FormData();
  //   data.append("file", postItem);
  //   debugger;
  //   let header = new Headers();
  //   header.append("apiKey", "5055b481-ecdb-48eb-a58e-d9b85961796c");
  //   let url = `${API.poUpload}`;
  //   return (dispatch) => {
  //     axios
  //       .post(url, data, {
  //         headers: header,
  //       })
  //       .then((response) => {
  //         debugger;
  //         // dispatch({
  //         //     type: "AttchmentUploaded",
  //         //     data: response.data,
  //         // })
  //       })
  //       .catch((error) => {
  //         debugger;
  //         // dispatch({
  //         //     type: "AttchmentUploadedFailure",
  //         //     error: "ERROR"
  //         // })
  //       });
  //   };
  var myHeaders = new Headers();
  myHeaders.append("apiKey", "5055b481-ecdb-48eb-a58e-d9b85961796c");
  myHeaders.append(
    "Authorization",
    "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjFvVnNMODh5dUJ0LVZYUG5Ub0s5YmciLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE2MzkyMTk2NjgsImV4cCI6MTY3MDc1NTY2OCwiaXNzIjoiaHR0cDovL3VhdC5tYXJpbmVtZWNoYW5pY3MuYml6OjgwMDEiLCJhdWQiOiJza29ydWJhX2lkZW50aXR5X2FkbWluX2FwaSIsImNsaWVudF9pZCI6IklITSIsInN1YiI6IjQ0MDlhZmVjLTcxYTgtNGM2OC04N2VhLTA5MWU4MGY5MWY4MiIsImF1dGhfdGltZSI6MTYzOTIxOTY2NSwiaWRwIjoibG9jYWwiLCJyb2xlIjoiYWRtaW4iLCJuYW1lIjoibW1wbGFkbWluQG1hcmluZW1lY2hhbmljcy5iaXoiLCJqdGkiOiIwdlAwYkpiV1BzUXNzY2pEZm5XVzFRIiwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsImVtYWlsIiwic2tvcnViYV9pZGVudGl0eV9hZG1pbl9hcGkiXSwiYW1yIjpbInB3ZCJdfQ.kFghLqESjPVHca5_vQvASbZctZmrghMzJmBUJ9yMop8aOfW3jKjSIDca_YIIsx_V9m0-TV-PFffQF_8c3WCphC8vkG7jGkUoTPy8v8jpT770DHHa4kYodSBvBnJKi1nUOte_GzhNwrRmnjEEOCA_DwsMqzfa92IifowElBMjHhSHTe97dSrL6wbt2bkmz_l1dMJDLDfHe5afqifoS1zAOFMNGn6fu3PcziYK8WxyYMepwsBRZR2l8QUEIBpLUERktohyCCW8o_FGouGisLAB_NoPjl1D0c87AJfv_MxxiUnQS_74EN_J8gAyeXRHZn_FOdBo3eEpzVhJLv12C0hvbA"
  );

  var formdata = new FormData();
  formdata.append("file", postItem);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };
  fetch(`${API.poUpload}`, requestOptions)
    // .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};
